// Shared formatting utilities

export function formatDateNL(iso) {
  if (!iso) return '—'
  try {
    const d = new Date(iso)
    return d.toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' })
  } catch {
    return iso
  }
}

export function padId(val, len = 8) {
  const n = Number(val)
  if (!Number.isFinite(n) || n <= 0) return val || ''
  try { return String(Math.trunc(n)).padStart(len, '0') } catch { return String(n) }
}

export function decodeHTML(str) {
  if (!str || typeof str !== 'string' || !str.includes('&')) return str || ''
  try {
    const doc = new DOMParser().parseFromString(str, 'text/html')
    return doc.documentElement.textContent || str
  } catch { return str }
}

export default { formatDateNL, padId, decodeHTML }
